import React from 'react';
import {Choice} from '../types';

type RadioButtonProps = {
    choices: Choice[];
    value: string;
    onChange: (value: any) => void;
};

export const RadioButton: React.FunctionComponent<RadioButtonProps> = ({
                                                                           choices,
                                                                           value,
                                                                           onChange
                                                                       }) => {
    return (
        <div>
            {choices.map((choice: Choice, index: number) => (
                <button key={index}
                        type="button"
                        className={'btn btn-lg mr-4 ' + ((value && value === choice.value) ? 'btn-secondary' : 'btn-outline-secondary')}
                        onClick={() => {onChange && onChange(choice.value)}}
                >{choice.label}</button>
            ))}
        </div>
    );
};